export class Maestro_CargasArchivos {
    id: number;
    ruta: string;
    descripcion: string;
    subirArchivo: boolean;
    eliminar: boolean;
    subdirectorios: boolean;
    activo: boolean;
    filtroArchivos: string;
    rolesSeleccionados: number[];
    usuariosSeleccionados: number[];
}
